import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { useState } from "@wordpress/element";
import { v4 as uuid } from "uuid";

type Props = {
	label?: string;
	help?: string;
	value?: string;
	onChange?: (value: string) => void;
	placeholder?: string;
	className?: string;
	name?: string;
};

export function PasswordInput({ label, help, value, onChange, placeholder, className, name }: Props) {
	const id = uuid();
	const [showPassword, setShowPassword] = useState(false);

	return (
		<label htmlFor={id} className={css("password-input-wrapper", className || "")}>
			{label && <span className={css("form-label")}>{label}</span>}
			<div className={css("password-input")}>
				<input
					id={id}
					name={name}
					type={showPassword ? "text" : "password"}
					className={css("form-input password-input__field")}
					value={value}
					onChange={(e) => onChange?.(e.target.value)}
					placeholder={placeholder || __("Enter password...", "antimanual")}
				/>
				<button
					type="button"
					className={css("password-input__toggle")}
					onClick={() => setShowPassword(!showPassword)}
					aria-label={showPassword ? __("Hide password", "antimanual") : __("Show password", "antimanual")}
				>
					{showPassword ? (
						// Eye-off icon (hide)
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
							<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
							<line x1="1" y1="1" x2="23" y2="23" />
						</svg>
					) : (
						// Eye icon (show)
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
							<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
							<circle cx="12" cy="12" r="3" />
						</svg>
					)}
				</button>
			</div>
			{help && <p className={css("form-help")}>{help}</p>}
		</label>
	);
}
